import { render, staticRenderFns } from "./boleto-generator.vue?vue&type=template&id=4e950175&scoped=true&"
import script from "./boleto-generator.vue?vue&type=script&lang=js&"
export * from "./boleto-generator.vue?vue&type=script&lang=js&"
import style0 from "./boleto-generator.vue?vue&type=style&index=0&id=4e950175&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e950175",
  null
  
)

export default component.exports